export enum CertificationDomains {
  Finance = 'finance'
}
